import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rdrx-material-annotations-list-footer',
  template: `
    <div id="annotation-list-footer">
      <button
        mat-flat-button
        color="primary"
        id="delete-button"
        data-automation-id="material-annotation-list-delete-button"
        class="btn btn-secondary"
        [disabled]="disableDeleteBtn"
        (click)="deleteClick.emit()"
      >
        {{ 'shared.delete' | translate }}
      </button>
      <button
        mat-button
        id="cancel-button"
        data-automation-id="material-annotation-list-cancel-button"
        class="btn btn-secondary"
        (click)="cancelClick.emit()"
      >
        {{ 'shared.cancel' | translate }}
      </button>
  </div>
  `,
  styleUrls: ['./annotation-list-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class MaterialAnnotationListFooterComponent {
  @Input({ required: true }) disableDeleteBtn!: boolean;
  @Input({ required: true }) isEditMode!: boolean;

  @Output() deleteClick = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();
}
